// -----------------Tag--------------
export const aTag = {
  data: [
    {
      id: 1,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ AA",
      tagNameEN: "PRINCIPAL iPROP-AA",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ AA|PRINCIPAL iPROP-AA",
      modify: "wipa.tri@principal.th",
      modifyDate: "16-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: []
    },
    {
      id: 2,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ B",
      tagNameEN: "PRINCIPAL iPROP-B",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ B|PRINCIPAL iPROP-B",
      modify: "wipa.tri@principal.th",
      modifyDate: "20-05-2021",
      type: "Fund tag",
      status: "Unpublish"
    },
    {
      id: 3,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ C",
      tagNameEN: "PRINCIPAL iPROP-C",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ C|PRINCIPAL iPROP-C",
      modify: "wipa.tri@principal.th",
      modifyDate: "15-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: ["iPROP-D", "iPROP-C"]
    },
    {
      id: 4,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ D",
      tagNameEN: "PRINCIPAL iPROP-D",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ D|PRINCIPAL iPROP-D",
      modify: "wipa.tri@principal.th",
      modifyDate: "15-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: ["iPROP-D", "iPROP-C"]
    },
    {
      id: 5,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ F",
      tagNameEN: "PRINCIPAL iPROP-F",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ D|PRINCIPAL iPROP-D",
      modify: "wipa.tri@principal.th",
      modifyDate: "15-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: ["iPROP-D", "iPROP-C"]
    },
    {
      id: 6,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ G",
      tagNameEN: "PRINCIPAL iPROP-G",
      modify: "wipa.tri@principal.th",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ G|PRINCIPAL iPROP-G",
      modifyDate: "15-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: ["iPROP-D", "iPROP-C"]
    },
    {
      id: 7,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ H",
      tagNameEN: "PRINCIPAL iPROP-H",
      modify: "wipa.tri@principal.th",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ H|PRINCIPAL iPROP-H",
      modifyDate: "15-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: ["iPROP-D", "iPROP-C"]
    },
    {
      id: 8,
      tagNameTH: "กองทุนเปิดพรินเพิล พร็อพ I",
      tagNameEN: "PRINCIPAL iPROP-I",
      modify: "wipa.tri@principal.th",
      tagNameShow: "กองทุนเปิดพรินเพิล พร็อพ I|PRINCIPAL iPROP-I",
      modifyDate: "15-02-2021",
      type: "Fund tag",
      status: "Unpublish",
      fundCodes: ["iPROP-D", "iPROP-C"]
    }
  ]
};
// -----------------SearcRec-----------------
export const aSrchRec = [
  {
    id: 1,
    fundTag: "Fund Tag A",
    fundTagId: 1,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  },
  {
    id: 2,
    fundTag: "Fund Tag B",
    fundTagId: 2,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  }
];
// -----------------ContendtFeed-------------
export const aMainMenu = [
  {
    no: "1",
    articleTitle: "abcd",
    interestCode: "xxx",
    modifiedBy: "admin",
    modifiedAt: "2000-10-11",
    statusCode: 1,
    uuid: "snjfoiergmfgmfaigjmiafgjioasmg"
  }
];
export const aContentFeed = [
  {
    id: "769",
    articleShow:
      "ทำไมเราถึงไม่ควรถอนเงินออกจากกองทุนสำรองเลี้ยงชีพ|Why you should not withdraw from provident fund?",
    articleTitleTh: "ทำไมเราถึงไม่ควรถอนเงินออกจากกองทุนสำรองเลี้ยงชีพ",
    articleTitleEn: "Why you should not withdraw from provident fund?",
    shortDesTh: null,
    shortDesEn: null,
    contentTh: "",
    contentEn: "",
    imageUrl:
      "https://www.principal.th/sites/default/files/media/Principal_WebContent%5B4_1314x668%5D_301020.png",
    videoUrl: "http://youtube.be/watch?v=MEuSOQqxORQ",
    tag: [],
    fund: [],
    showUser: null,
    statusCode: 0,
    contentType: "Old",
    isHighlight: null,
    fileUrl: null,
    modifiedBy: "Auto Service",
    modifiedAt: "2021-06-15",
    createdAt: "2021-06-15"
  }
];

// --------------FundRecommend---------------
export const aFunRecCodi = [
  {
    id: 1,
    conditionName: "แนะนำ Iprop A | 25-30 ไม่มี กอง iprop ",
    modify: "wipa.tri@principal.th",
    createDate: "01-05-2021",
    modifyDate: "20-05-2021",
    status: "Publish",
    hightlight: true,
    RuleName2: "ชื่อกฏกฏติกา",
    ordUsr2: "All",
    fundCode: ["IPROR-A", "IPROP-B"],
    Condition: [
      {
        IdUni: "asdassdfdslkjsad",
        Type: "C001",
        line1: "10-20",
        line2: "",
        rage1: "1",
        rage2: "2"
      },
      {
        IdUni: "jkvdvou",
        Type: "C002",
        line1: ["กองทุนรวม", "กองทุนแนะนำ"],
        line2: "OR",
        rage1: "",
        rage2: ""
      },
      {
        IdUni: "okkisfl",
        Type: "C003",
        line1: ["กองทุนรวม", "กองทุนแนะนำ"],
        line2: "OR",
        rage1: "",
        rage2: ""
      }
    ]
  },
  {
    id: 2,
    conditionName: "แนะนำ Iprop B | 40-60 มี กอง iprop ",
    modify: "wipa.tri@principal.th",
    createDate: "11-05-2021",
    modifyDate: "20-05-2021",
    status: "Unpublish",
    hightlight: false,
    RuleName2: "ชื่อกฏกฏติกา",
    ordUsr2: "All",
    Condition: null,
    fundCode: null
  },
  {
    id: 3,
    conditionName: "แนะนำ Iprop C | 60-70 ไม่มี กอง iprop ",
    modify: "wipa.tri@principal.th",
    createDate: "20-05-2021",
    modifyDate: "20-05-2021",
    status: "Unpublish",
    RuleName2: "ชื่อกฏกฏติกา",
    ordUsr2: "All",
    hightlight: false,
    Condition: null,
    fundCode: null
  }
];
export const aFunRecRisk = {
  data: [
    {
      No: "1",
      RiskName: "เสี่ยงต่ำ",
      Modify: "Pongsa@gmail.com",
      CreatDate: "03/05/2021",
      ModifyDate: "03/05/2021",
      Rule: [
        {
          IdUni: "asdassdfdslkjsad",
          otbNameTH2: "ชื่อไทยๆ1Fix",
          otbNameEN2: "Name1",
          otbPer2: "10",
          ordSta2: "Over",
          fundCode: ["IPROR-A", "IPROP-B"]
        },
        {
          IdUni: "4dsvwfjsvouiu",
          otbNameTH2: "ชื่อไทยๆ2",
          otbNameEN2: "Name2",
          otbPer2: "20",
          ordSta2: "NoOver",
          fundCode: ["IPROR-A"]
        }
      ]
    },
    {
      No: "2",
      RiskName: "เสี่ยงปานกลางค่อนข้างต่ำ",
      Modify: "Pongsa@gmail.com",
      CreatDate: "04/05/2021",
      ModifyDate: "03/05/2021",
      Rule: null
    },
    {
      No: "3",
      RiskName: "เสี่ยงปานกลางค่อนข้างสูง",
      Modify: "Pongsa@gmail.com",
      CreatDate: "29/04/2021",
      ModifyDate: "03/05/2021",
      Rule: null
    },
    {
      No: "4",
      RiskName: "เสี่ยงสูง",
      Modify: "Sagas@gmail.com",
      CreatDate: "20/04/2021",
      ModifyDate: "03/05/2021",
      Rule: null
    },
    {
      No: "5",
      RiskName: "เสี่ยงสูงมาก",
      Modify: "Madamed@gmail.com",
      CreatDate: "19/04/2021",
      ModifyDate: "03/05/2021",
      Rule: null
    }
  ]
};
export const aOccupa = [
  {
    OccuId: "OCU001",
    OccuTH: "เกษตรกร",
    OccuEN: "Agriculturist"
  },
  {
    OccuId: "OCU002",
    OccuTH: "แม่บ้าน/พ่อบ้าน",
    OccuEN: "Housewife"
  },
  {
    OccuId: "OCU003",
    OccuTH: "พระภิกษุ/นักบวช",
    OccuEN: "Buddhist Monk/Priest"
  },
  {
    OccuId: "OCU004",
    OccuTH: "นักลงทุน",
    OccuEN: "Investor"
  },
  {
    OccuId: "OCU005",
    OccuTH: "เกษียณอายุ",
    OccuEN: "Retirement"
  },
  {
    OccuId: "OCU006",
    OccuTH: "พนักงานรัฐวิสาหกิจ",
    OccuEN: "State Enterprise Employee"
  },
  {
    OccuId: "OCU007",
    OccuTH: "กิจการครอบครัว",
    OccuEN: "Family Businness"
  },
  {
    OccuId: "OCU008",
    OccuTH: "ครู/อาจารย์",
    OccuEN: "Teacher"
  },
  {
    OccuId: "OCU0009",
    OccuTH: "ข้าราชการ",
    OccuEN: "Government Employee"
  },
  {
    OccuId: "OCU010",
    OccuTH: "อาชีพอิสระ",
    OccuEN: "Self-Employed"
  },
  {
    OccuId: "OCU011",
    OccuTH: "พนักงานบริษัท",
    OccuEN: "Corporate Employee"
  },
  {
    OccuId: "OCU012",
    OccuTH: "แพทย์/พยาบาล",
    OccuEN: "Doctor/Nurse"
  },
  {
    OccuId: "OCU013",
    OccuTH: "นักการเมือง",
    OccuEN: "Politician"
  },
  {
    OccuId: "OCU014",
    OccuTH: "อื่นๆ(โปรดระบุ)",
    OccuEN: "other(Please specify)"
  }
];
export const aIncome = [
  {
    id: "I001",
    income: "0-15,000"
  },
  {
    id: "I002",
    income: "15,001-30,000"
  },
  {
    id: "I003",
    income: "30,001-50,000"
  },
  {
    id: "I004",
    income: "50,001-100,000"
  },
  {
    id: "I005",
    income: "100,000-500,000"
  },
  {
    id: "I006",
    income: "500,001-1,000,000"
  },
  {
    id: "I007",
    income: "1,000,001-4,000,000"
  },
  {
    id: "I008",
    income: "4,000,001-10,000,000"
  },
  {
    id: "I009",
    income: ">10,000,000"
  }
];
// --------------FundRisk------------
export const aRiskLv = [
  {
    RiskLvNo: "1",
    RiskLv: "เสี่ยงต่ำ"
  },
  {
    RiskLvNo: "2",
    RiskLv: "เสี่ยงปานกลางค่อนข้างต่ำ"
  },
  {
    RiskLvNo: "3",
    RiskLv: "เสี่ยงปานกลางค่อนข้างสูง"
  },
  {
    RiskLvNo: "4",
    RiskLv: "เสี่ยงสูง"
  },
  {
    RiskLvNo: "5",
    RiskLv: "เสี่ยงสูงมาก"
  }
];
export const aOrder = [
  {
    value: "1",
    label: 1
  },
  {
    value: "2",
    label: 2
  },
  {
    value: "3",
    label: 3
  },
  {
    value: "4",
    label: 4
  },
  {
    value: "5",
    label: 5
  },
  {
    value: "6",
    label: 6
  },
  {
    value: "7",
    label: 7
  },
  {
    value: "8",
    label: 8
  },
  {
    value: "9",
    label: 9
  },
  {
    value: "10",
    label: 10
  }
];
// ------------Fund list------------
export const aFundList = {
  data: [
    {
      fund_code: null,
      website: "Thailand",
      fund_name: "Principal Aggressive Allocation Retirement Mutual Fund",
      fund_category: "LTF-RMF-SSF Fund",
      fund_article_initial: "Fund Article Intitial Sample Data1",
      launch_date: "2001-01-01T00:00:00.000Z",
      fund_currency: "THB",
      closed_date: "2030-01-01T00:00:00.000Z",
      fund_photo_url:
        "https://www.principal.th/sites/default/files/2020-11/1_photo.jpg",
      maturity_date: "2019-12-28T00:00:00.000Z",
      risk_level: 7,
      prospectus_url:
        "https://www.principal.th/sites/default/files/fund-documents/Thailand%20Site/en_PRINCIPAL_AARMF_Prospectus_Full.pdf",
      fund_fact_sheet_url:
        "https://www.principal.th/sites/default/files/fund-documents/Thailand%20Site/en_PRINCIPAL_AARMF_FFS.pdf",
      product_highlight_sheet_url:
        "https://www.principal.th/sites/default/files/fund-documents/Thailand%20Site/Investor-Guide_EN.pdf",
      fund_no: 1,
      fund_manager:
        "Win Phromphaet\nWasin Parithan\nThanut Jadejunprapa\nPunyanoot Punyaratabandhu\nChatree Meechaijaroenying\nWitthaya Chancharuschot\nViriya Phokaisawan\nPaniti Jittriphot\nWaroon Saptaweekul\nThana Sheanakul \nPrapot Uancharoenkul",
      fund_type: "Mixed Fund, Fund of Funds, RMF",
      fund_size: "1,000 Million Baht",
      dividend_policy: "None",
      benchmark:
        "STGovBond Index 10% + SET50 TRI Index 45% + M1WO index adjusted with FX hedging cost 22.5% + M1WO Index (THB) 22.5%",
      hedging_policy: "According to the discretion of fund manager",
      subscription_period:
        "Every business day from bank business hours to 3.30 pm",
      subscription_period_after_ipo:
        "Every business day from bank business hours to 3.30 pm",
      redemption_period:
        "Every business day from bank business hours to 3.30 pm",
      inception_date: "2004-12-13T00:00:00.000Z",
      minimum_subscription: "2,000 Baht",
      next_subscription: "2,000 Baht",
      settlement:
        "Within 5 business days (Currently T+4) CIMBT / SCB / KBANK / BAY/ TMB / BBL /LHBANK/ KK/ TBANK",
      dividend_payment_history: "Dividend Payment History Sample Data",
      investment_policy:
        "The fund has a policy to invest in investment units of other mutual funds that have a policy of investing in equity instruments which will result in net exposure funds in CIS units of such fund, on average for fiscal year not less than 80 percent of the net asset value of the fund. The remaining portion will be invested in other securities or assets or other methods of seeking profits according to SEC announcement.",
      minimum_redemption: "2,000 Baht",
      front_end_fee_and_switching_in_fee_prospectus: "None",
      front_end_fee_and_switching_in_fee_actual: "None",
      back_end_fee_and_switching_out_fee_prospectus: "None",
      back_end_fee_and_switching_out_fee_actual: "None",
      brokerage_fee_prospectus: "None",
      brokerage_fee_actual: "None",
      management_fee_prospectus: "Not exceed 1.07%",
      management_fee_actual: "Currently 1.070%",
      trustee_fee_prospectus: "Not exceed 0.12%",
      trustee_fee_actual: "Currently 0.048%",
      registration_fee_prospectus: "Not exceed 0.15%",
      registration_fee_actual: "Currently 0.075%",
      created_at: [
        "2020-05-06T07:46:23.233Z",
        "2020-05-06T07:45:14.227Z",
        "2020-05-11T04:49:28.347Z"
      ],
      created_by: [
        "f2d4b229-6981-483f-ae4b-6501ac51b2eb",
        "f2d4b229-6981-483f-ae4b-6501ac51b2eb",
        "37B8A9FC-B19B-4DF1-9760-9E69A60D8520"
      ],
      updated_at: [
        "2021-06-30T08:18:42.987Z",
        "2021-06-30T08:18:43.367Z",
        "2021-06-30T08:18:43.367Z"
      ],
      updated_by: [
        "93CD7E17-9DB5-4768-9751-0953D1E86F8E",
        "93CD7E17-9DB5-4768-9751-0953D1E86F8E",
        "93CD7E17-9DB5-4768-9751-0953D1E86F8E"
      ],
      dividend_policy_status: "0",
      active: true,
      last_active_date: null,
      can_buy: true,
      can_topup: true,
      can_switch: true,
      can_redeem: true,
      recommend: true,
      ipo_status: 0,
      ipo_started_date: null,
      ipo_ended_date: null,
      country_code: "TH",
      returnytd: -12.137,
      return03m: -10.6668,
      return06m: -9.6902,
      return12m: -12.1447,
      return03y: -1.4259,
      return05y: -0.3053,
      return10y: 2.6033,
      returnsin: 1.5769,
      navperunit: 13.3215,
      totalnav_mb: 22.165235,
      NAV_EffDate: "6/16/2020 12:00:00 AM",
      sync_updated_at: ["2021-07-12T15:42:09.000Z", "2021-07-12T15:42:09.000Z"],
      first_lowbuy_val: 2000,
      next_lowbuy_val: 0.01,
      AssetClassNameEN: "LTF/RMF",
      Fund_No: "1",
      Fund_Code: "PRINCIPAL AARMF_OLD",
      NAVperUnit: "13.3215"
    }
  ]
};
// -------------Register Device--------
export const aRegisDevice = [
  {
    customer_uuid: "3c6fea13-c6ba-4f90-aba0-22d841509cf2",
    email: "test@gmail.com",
    firebase_fid: "fid_1",
    app_version: "1.5.6",
    app_platform: "iOS",
    device_name: "iPhone 12 Max",
    register_status: "inactive",
    registered_at: "2021-06-01 12:11:12",
    deregistered_at: "2021-06-01 17:11:56",
    register_ip_address: "18.141.105.230"
  },
  {
    customer_uuid: "c43d5a0a-96ff-40e1-a005-eb0722cca030",
    email: "nuttapon@gmail.com",
    firebase_fid: "fid_2",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "Samsung A8",
    register_status: "active",
    registered_at: "2021-06-10 12:11:12",
    deregistered_at: "2021-06-11 17:11:56",
    register_ip_address: "18.150.150.200"
  },
  {
    customer_uuid: "de67127d-043e-4a40-83cc-89440a85080c",
    email: "nutto@gmail.com",
    firebase_fid: "fid_3",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "Samsung A1",
    register_status: "active",
    registered_at: "2021-06-15 12:11:12",
    deregistered_at: "2021-06-18 17:11:56",
    register_ip_address: "18.150.150.201"
  },
  {
    customer_uuid: "78a698d0-df5c-42d2-9af0-40d3613a4c3e",
    email: "chomsombat@gmail.com",
    firebase_fid: "fid_3",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "Samsung A1",
    register_status: "active",
    registered_at: "2021-04-01 12:11:12",
    deregistered_at: "2021-04-05 17:11:56",
    register_ip_address: "18.150.150.200"
  },
  {
    customer_uuid: "845c3b31-19fc-4ebc-ba71-4310463a61e0",
    email: "patara@gmail.com",
    firebase_fid: "fid_4",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "oppo reno5",
    register_status: "active",
    registered_at: "2021-06-01 12:11:12",
    deregistered_at: "2021-06-05 17:11:56",
    register_ip_address: "18.120.150.200"
  },
  {
    customer_uuid: "ca4a86f4-8a93-4129-a59a-fa2eb5da0617",
    email: "songthai@gmail.com",
    firebase_fid: "fid_5",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "oppo reno7",
    register_status: "active",
    registered_at: "2021-06-01 12:11:12",
    deregistered_at: "2021-06-05 17:11:56",
    register_ip_address: "18.110.150.123"
  },
  {
    customer_uuid: "e06e5a80-1289-4958-8711-b24452258437",
    email: "aranya@gmail.com",
    firebase_fid: "fid_5",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "huawei p40 pro",
    register_status: "active",
    registered_at: "2021-01-01 12:11:12",
    deregistered_at: "2021-01-05 17:11:56",
    register_ip_address: "19.110.200.123"
  },
  {
    customer_uuid: "a9afdcc7-9a3f-4f7b-991a-fa3de09dd603",
    email: "uravee@gmail.com",
    firebase_fid: "fid_6",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "huawei p40 pro",
    register_status: "active",
    registered_at: "2021-01-11 12:11:12",
    deregistered_at: "2021-01-12 17:11:56",
    register_ip_address: "18.110.150.103"
  },
  {
    customer_uuid: "185f241b-a2a5-4a6c-a606-19f5ef81eef1",
    email: "yuwadee@gmail.com",
    firebase_fid: "fid_7",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "SONY Xperia X",
    register_status: "active",
    registered_at: "2021-03-29 12:11:12",
    deregistered_at: "2021-04-01 17:11:56",
    register_ip_address: "18.110.151.123"
  },
  {
    customer_uuid: "d27fc9de-274e-4c32-be29-491866ba799d",
    email: "oracle@gmail.com",
    firebase_fid: "fid_8",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "vivo v20",
    register_status: "active",
    registered_at: "2021-02-01 12:11:12",
    deregistered_at: "2021-02-05 17:11:56",
    register_ip_address: "18.110.110.123"
  },
  {
    customer_uuid: "fd09a42e-70c5-4f74-9721-7c84a39868ea",
    email: "dong@gmail.com",
    firebase_fid: "fid_9",
    app_version: "1.5.6",
    app_platform: "Android",
    device_name: "huawei p40 pro",
    register_status: "active",
    registered_at: "2021-03-01 12:11:12",
    deregistered_at: "2021-03-05 17:11:56",
    register_ip_address: "18.110.150.123"
  },
  {
    customer_uuid: "739bb9eb-cf69-4767-b93a-24d878131893",
    email: "jojo@gmail.com",
    firebase_fid: "fid_10",
    app_version: "1.5.6",
    app_platform: "iOS",
    device_name: "iPhone 12",
    register_status: "active",
    registered_at: "2021-01-01 12:11:12",
    deregistered_at: "2021-01-05 17:11:56",
    register_ip_address: "18.110.150.123"
  }
];
// -------------Activity Log--------
export const aActi = [
  {
    id: 1,
    device_name: "ChromeV91",
    firebase_fid: "-",
    app_version: "1.0",
    app_platform: "Web",
    created_at: "2021-06-01 12:11:12",
    UserType: "Admin",
    activity_type: "ApproveClient",
    activity_data: "Mr.Arus Tara",
    email: "Arus@Gmail.com",
    ip_address: "18.141.105.230",
    customer_uuid: "sdidfnaois-sidnvas-himngo"
  },
  {
    id: 2,
    device_name: "123",
    firebase_fid: "idFake",
    app_version: "1.0",
    app_platform: "Web",
    created_at: "2021-06-11 12:11:12",
    UserType: "Admin",
    activity_type: "ApproveClient",
    activity_data: "Mr.Te A",
    email: "Arus@Gmail.com",
    ip_address: "18.111.105.432",
    customer_uuid: "thn-adb-12"
  }
];

// -------------NDID List--------
export const aNDID = [
  {
    id: 1,
    CreatAt: "09/09/2021",
    IdCard: "1809900911751",
    TitleNameTh: "นางสาว",
    FirstNameTh: "วรรณนิภา",
    LastNameTh: "กลิ่นโพธิ์",
    TitleNameEn: "Ms.",
    FirstNameEn: "WANNIPA",
    LastNameEn: "KLINPHOH",
    BirthDate: "08/09/1998",
    IssuedDate: "25/10/2013",
    ExpireDate: "06/10/2022",
    AddressNo: "99/9",
    AddressMoo: "2",
    AddressAlley: "-",
    AddressSoi: "-",
    AddressRoad: "-",
    AddressTambol: "สุรศักดิ์",
    AddressAmphur: "ศรีราชา",
    AddressProvince: "ชลบุรี",
    ZipCode: "20110",
    MobileNo: ":0807643355",
    Image: ""
  },
  {
    id: 2,
    CreatAt: "09/09/2021",
    IdCard: "1330300202020",
    TitleNameTh: "นาย",
    FirstNameTh: "นัฐพล",
    LastNameTh: "ชมสมบัติ",
    TitleNameEn: "Mr.",
    FirstNameEn: "Nuttapon",
    LastNameEn: "Chomsombat",
    BirthDate: "08/09/1998",
    IssuedDate: "25/10/2013",
    ExpireDate: "06/10/2022",
    AddressNo: "99/9",
    AddressMoo: "2",
    AddressAlley: "-",
    AddressSoi: "-",
    AddressRoad: "-",
    AddressTambol: "ดูน",
    AddressAmphur: "กันทรารมณ์",
    AddressProvince: "ศรีสะเกษ",
    ZipCode: "33130",
    MobileNo: "0851111111",
    Image:
      "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"
  }
];
export const aCtm = [
  {
    id: 1,
    CreatAt: "09/09/2021",
    IdCard: "1809900911751",
    TitleNameTh: "นางสาว",
    FirstNameTh: "สิริพา",
    LastNameTh: "นักค้นหา",
    TitleNameEn: "Ms.",
    FirstNameEn: "Siripha",
    LastNameEn: "Nukkhonha",
    BirthDate: "08/09/2000",
    IssuedDate: "25/10/2013",
    ExpireDate: "06/10/2032",
    AddressNo: "11/1",
    AddressMoo: "2",
    AddressAlley: "-",
    AddressSoi: "-",
    AddressRoad: "-",
    AddressTambol: "อันแสนไกล",
    AddressAmphur: "เมือง",
    AddressProvince: "ขอนแจ่น",
    ZipCode: "20110",
    MobileNo: ":085555555",
    Image: ""
  }
];

// -------------User Account List--------
export const aUsrAct = {
  Customer: [
    {
      id: null,
      created_at: null,
      customer_uuid: null,
      UnitCount: null,
      CUS_Detail: null,
      CUS_Pentacle: null,
      CUS_User: null,
      CUS_progress: null
    }
  ],
  TotalCustomer: 0
};
export const aConsentType = [
  {
    value: "0",
    label: "All"
  },
  {
    value: "1",
    label: "Term & Con App"
  },
  {
    value: "2",
    label: "Consent Marketing"
  },
  {
    value: "3",
    label: "Term & Con MF"
  },
  {
    value: "4",
    label: "Consent RMF/SSF"
  },
  {
    value: "5",
    label: "NDID"
  }
];
// -----------Other ------------
export const aTagFundCode = {
  data: [
    {
      ID: "F001",
      Fundcode: "Fund Name1_Fix",
      ModifyDate: "17-02-2021"
    },
    {
      ID: "F002",
      Fundcode: "Fund Name2",
      ModifyDate: "11-02-2021"
    },
    {
      ID: "F003",
      Fundcode: "Fund Name3",
      ModifyDate: "02-02-2021"
    },
    {
      ID: "F004",
      Fundcode: "IPROP",
      ModifyDate: "01-02-2021"
    },
    {
      ID: "F005",
      Fundcode: "IPROR-A",
      ModifyDate: "16-03-2021"
    },
    {
      ID: "F006",
      Fundcode: "IPROP-B",
      ModifyDate: "16-04-2021"
    },
    {
      ID: "F007",
      Fundcode: "IPROP C",
      ModifyDate: "11-11-2021"
    },
    {
      ID: "F008",
      Fundcode: "กองทุนรวม",
      ModifyDate: "11-02-2021"
    },
    {
      ID: "F009",
      Fundcode: "กองทุนแนะนำ",
      ModifyDate: "11-02-2021"
    },
    {
      ID: "53",
      Fundcode: "PRINCIPAL DEF",
      ModifyDate: "11-02-2021"
    },
    {
      ID: "81",
      Fundcode: "PRINCIPAL TREASURY",
      ModifyDate: "11-02-2021"
    }
  ]
};

export const aTagFundByRisk = {
  data: [
    {
      ID: 1,
      Fundcode: "Fund Name1_Fix",
      ModifyDate: "17-02-2021"
    },
    {
      ID: 53,
      Fundcode: "PRINCIPAL DEF",
      ModifyDate: "11-02-2021"
    },
    {
      ID: 81,
      Fundcode: "PRINCIPAL TREASURY",
      ModifyDate: "11-02-2021"
    }
  ]
};
export const aFunRecCodiCode = {
  data: [
    {
      ID: "C001",
      Condition: "อายุ"
    },
    {
      ID: "C002",
      Condition: "กองทุนที่มีใน Port ลูกค้า"
    },
    {
      ID: "C003",
      Condition: "กองทุนที่ไม่มีใน Port ลูกค้า"
    },
    {
      ID: "C004",
      Condition: "อาชีพ"
    },
    {
      ID: "C005",
      Condition: "รายได้"
    },
    {
      ID: "C006",
      Condition: "ระดับความเสี่ยง"
    },
    {
      ID: "C008",
      Condition: "จำนวนเงินใน Port"
    },
    {
      ID: "C009",
      Condition: "วัตถุประสงค์ในการลงทุน"
    }
  ]
};
export const aSrchRecFundTag = [
  {
    id: 1,
    fundTag: "Fund Tag A",
    fundTagId: 3,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  },
  {
    id: 2,
    fundTag: "Fund Tag B",
    fundTagId: 4,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  },
  {
    id: 3,
    fundTag: "Fund Tag C",
    fundTagId: 5,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  },
  {
    id: 4,
    fundTag: "Fund Tag D",
    fundTagId: 6,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  },
  {
    id: 5,
    fundTag: "Fund Tag F",
    fundTagId: 7,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  },
  {
    id: 6,
    fundTag: "Fund Tag G",
    fundTagId: 8,
    modify: "wipa.tri@principal.th",
    modifyDate: "15-02-2021",
    createDate: "15-02-2021"
  }
];
export const aInvestObj = [
  {
    id: "401",
    NameTH: "เพื่อการลงทุน",
    NameEN: "For Investment"
  },
  {
    id: "403",
    NameTH: "เพื่อสิทธิประโยชน์ทางภาษี",
    NameEN: "For Tax Benefits"
  },
  {
    id: "402",
    NameTH: "เพื่อการเกษียณ",
    NameEN: "Retirement Investment"
  },
  {
    id: "404",
    NameTH: "อื่นๆ",
    NameEN: "Other (Please specify)"
  }
];

export const tTestBody = "zz";

export const tImg = "";
